export default __webpack_public_path__ + "static/whatsappCrmBg-2169af8448e0a0c9b79551b66541fa4a.png";